import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'choseSeparateFiles',
    'choseSingleFile',
    'driversLicenseNotice',
    'fileBackInputBlock',
    'fileFrontAndBackInputBlock',
    'selectedKycType',
    'singleOrSeparateFileChoiceButtons',
  ];

  connect() {
    this.toggleSingleFileOrMultipleFilesMenu();
  }

  toggleSingleFileOrMultipleFilesMenu() {
    this.#showInputsIfATypeIsSelected();
    this.#toggleSingleOrSeparateFileChoiceButtons();
    this.toggleFileBackInput();
  }

  toggleFileBackInput() {
    if (this.choseSeparateFilesTarget.checked && this.#canSelectedDocumentTypeHaveABack()) {
      this.fileBackInputBlockTarget.classList.remove('d-none');
      this.fileBackInputBlockTarget.querySelectorAll('[name*="[file_back]"]').forEach((el) => (el.disabled = false));
      this.fileFrontAndBackInputBlockTarget.classList.add('row-cols-md-2');
    } else {
      this.fileBackInputBlockTarget.classList.add('d-none');
      this.fileBackInputBlockTarget.querySelectorAll('[name*="[file_back]"]').forEach((el) => (el.disabled = true));
      this.fileFrontAndBackInputBlockTarget.classList.remove('row-cols-md-2');
    }
  }

  // private

  #toggleSingleOrSeparateFileChoiceButtons() {
    this.singleOrSeparateFileChoiceButtonsTarget.classList.toggle('d-none', !this.#canSelectedDocumentTypeHaveABack());
    if (this.#canSelectedDocumentTypeHaveABack()) {
      this.choseSingleFileTarget.checked = false;
      this.choseSeparateFilesTarget.checked = true;
    }
  }

  #canSelectedDocumentTypeHaveABack() {
    return this.selectedKycTypeTarget.options[this.selectedKycTypeTarget.selectedIndex].dataset.mayHaveBack === 'true';
  }

  #showInputsIfATypeIsSelected() {
    if (this.selectedKycTypeTarget.selectedIndex == 0) {
      this.fileFrontAndBackInputBlockTarget.classList.add('d-none');
    } else {
      this.fileFrontAndBackInputBlockTarget.classList.remove('d-none');
      this.#toggleDriversLicenseNotice();
    }
  }

  #toggleDriversLicenseNotice() {
    // Selected values are Lemonway document types
    if (this.selectedKycTypeTarget.selectedOptions[0].value == 11) {
      this.driversLicenseNoticeTarget.classList.remove('d-none');
    } else {
      this.driversLicenseNoticeTarget.classList.add('d-none');
    }
  }
}
